// extracted by mini-css-extract-plugin
export default {"itemText":"SidebarMenuItem_itemText__TUMnn"};